import { createContext, useContext } from "react";

import { CurrentUserContextType } from "./CurrentUserContextProvider.types.ts";

const CurrentUserContext = createContext<CurrentUserContextType>({} as CurrentUserContextType);

export default CurrentUserContext;

export const useCurrentUserContext = () => useContext(CurrentUserContext);
